<div class="flex my-9 w-full justify-between">
    <div class="flex gap-2">
        <button *ngIf="displayBackButton" class="bg-white border-none" (click)="backButton()">
            <img
                src="assets/images/arr-arrow-left-icon.svg"
                alt="left pointing arror"
                class="size-6"
            />
        </button>
        <img
            src="assets/images/mgo-logo-black.svg"
            alt="Moneygram Logo"
            class="w-32"
        />
    </div>
    <div class="flex gap-2">
        <app-language-selector
          [languages]="languageList"
          [labels]="(cmsLabels$ | async)?.labels"
        ></app-language-selector>
        <app-card-customer-support
            [labels]="(cmsLabels$ | async)?.labels"
        ></app-card-customer-support>
    </div>
</div>
